import OpenOrders from './OpenOrders';
import LoadUserData from '../../LoadUserData';

export const OpenordersConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth: ['investors','super'],
    routes  : [
        {
            path     : '/openorders/:shortcode',
            component: LoadUserData(OpenOrders)
        },
        {
            path     : '/openorders',
            component: LoadUserData(OpenOrders)
        }
    ]
};
